import React from 'react'
import HeroImage from '../assets/heroimage.png'
import {TiArrowRightThick} from "react-icons/ti"

const Home = () => {
  return (
    <div name="home" className='h-screen w-full bg-gradient-to-b from-black via-black to-gray-800' > 
       
      <div className='max-w-screen-lg mx-auto flex flex-col items-center justify-center h-full px-4 md:flex-row'>
        <div className='flex flex-col justify-center h-full'>
            <h2 className='text-4xl sm:text-7xl font-bold text-white'>Looking for a Full Stack Developer? Well, I am right here! </h2>
            <p className='text-gray-500 py-4 max-w-md'>
                I have 2 years of experience building and designing software.
                Currently I have focused on developing web applications using 
                technologies like JavaScript, React, Tailwind and Next JS for my frontend designs, GraphQL query language to build my APIs
                and Ruby for my backend.
            </p>
            <div>
                <button className='group text-white w-fit px-6 py-3 my-2 flex items-center rounded-md bg-gradient-to-r from-cyan-500 to-blue-500 cursor-pointer'>
                    Portfolio
                    <span className='group-hover:rotate-90 duration-300'>
                    <TiArrowRightThick size={25} className='ml-1'/>
                    </span>
                </button>
            </div>
        </div>
        <div>
            <img src={HeroImage} alt="my profile" className='rounded-2xl mx-auto w-2/3 md:w-full'/>
        </div>


      </div>
    </div>
  )
}

export default Home